module.exports = __webpack_public_path__ + "img/noFaceImg@2x.5b0a88bb.png";